import { Component, Input } from '@angular/core';
import { computed, signal } from '@angular/core';
import { input } from '@angular/core';
import { FormField } from '@angular/forms/signals';
import { ValidationErrors } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NzListModule } from 'ng-zorro-antd/list';
@Component({
  selector: 'app-field-error',
  imports: [CommonModule, NzListModule],
  templateUrl: './field-error.html',
  styleUrl: './field-error.scss',
})
export class FieldErrorsComponent {
  readonly control = input<{
    invalid(): boolean;
    touched(): boolean;
    dirty(): boolean;
    errors(): any[];
  } | null>(null);
  readonly submitted = input<boolean>(false);
  readonly messages: Record<string, string> = {
    required: 'Pole jest wymagane',
    email: 'Niepoprawny adres e-mail',
    minlength: 'Za mało znaków',
    maxlength: 'Za dużo znaków',
  };

  readonly shouldShow = computed(() => {
    return this.control()?.invalid() ?? false;
  });
}
